var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-oi"},[_c('div',{staticClass:"logo-img"},[_c('v-img',{attrs:{"src":require('../assets/images/logo_nova_oi_test.png'),"width":"42","contain":""}})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-text"},[_c('span',{staticClass:"header--title"},[_vm._v("CENTRAL DE AJUDA DE ACESSOS")])])
}]

export { render, staticRenderFns }